import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import LicenseContent from "./licenseContent";
import { Divider, Grid } from "@mui/material";
import { Icon } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const AboutPage: React.FC = () => {
  return (
    <Grid container direction="column" className={cssExports.about} rowGap={3}>
      <Grid item container className={cssExports.formSectionHeader} alignItems="center" spacing={2} marginBottom={2}>
        <Grid item container direction="row">
          <Grid item>
            <Icon icon={IconDefinitionConstants.WInfo} />
          </Grid>
          <Grid item>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.About.LicenseAttributions)}</Grid>
        </Grid>
        <Grid item container className={cssExports.border}>
          <Divider className={cssExports.dividerGray} />
        </Grid>

        <Grid item container direction="column" rowGap={2}>
          <Grid item className={cssExports.titleInfo}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.About.LicenseSubText1)}
          </Grid>
          <Grid item className={cssExports.titleInfo}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.About.LicenseSubText2)}
          </Grid>
        </Grid>
      </Grid>
      <LicenseContent
        moduleName={"caniuse-lite"}
        gitHubLink={{ url: "https://github.com/browserslist/caniuse-lite", text: "caniuse-lite" }}
        licenceUrl="https://github.com/browserslist/caniuse-lite/blob/main/LICENSE"
        infoText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.About.NotModifiedInfoText)}
      />
      <Grid item container className={cssExports.border}>
        <Divider className={cssExports.dividerGray} />
      </Grid>
      <LicenseContent
        moduleName={"spdx-exceptions"}
        gitHubLink={{ url: "https://github.com/jslicense/spdx-exceptions.json", text: "spdx-execeptions.json" }}
        licenceUrl="https://github.com/jslicense/spdx-exceptions.json/blob/master/README.md"
        infoText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.About.NotModifiedInfoText)}
      />
    </Grid>
  );
};

export default AboutPage;
